<template>
  <div class="container">
    <div class="tasks">
      <table-overview
        endpoint="queue/task"
        responseFormat="tasks"
        :customEvents="true"
        :columns="columns.tasks"
        :permission="permission"
        :module="module"
        :pagination="false"
        :selectable="false"
        tableHeight="calc(50vh - 135px)"
      ></table-overview>
    </div>
    <div class="queue">
      <table-overview
        endpoint="queue"
        responseFormat="queue"
        :customEvents="true"
        :columns="columns.queue"
        :permission="permission"
        :module="module"
        :pagination="false"
        :selectable="false"
        tableHeight="calc(50vh - 105px)"
      ></table-overview>
    </div>
    <!-- #region start task parameters modal -->
    <q-modal
      v-model="structure.startTaskParametersModalVisible"
      :content-css="{ minWidth: '40ch' }"
    >
      <q-modal-layout>
        <div
          class="layout-padding properties"
          v-if="selectedTaskStructure"
        >
        <div class="properties__header">
          <h1>{{ $store.state.stringsStore.language === 'nl'? 'Selecteer de opties voor het script:' : 'Select the options for the script:' }} </h1>
          <span>
            <p><label>{{ getString('module.queue.task.task') }}:</label> {{ getString(structure.selectedTask.label) }}</p>
            <p><label>{{ getString('module.queue.task.description.title') }}:</label> {{ getString(structure.selectedTask.description) }}</p>
          </span>
        </div>
        <div class="properties__content">
          <template v-for="item in selectedTaskStructure">
            <q-input
              v-if="item[1].type === 'text'"
              v-model="structure.parameters[item[0].split('.').pop()]"
              :key="item[0]"
              :float-label="getString(item[1].label)"
              type="text"
            ></q-input>
            <q-search
                v-if="item[1].type === 'item-code'"
                :key="item[0]"
                type="text"
                v-model="structure.parameters[item[0].split('.').pop()]"
                no-icon
                :float-label="getString(item[1].label)">
                <q-autocomplete
                  :max-results="25"
                  :min-characters="2"
                  @search="searchItem"
                  @selected="itemSelected(item[0].split('.').pop(),...arguments)" />
            </q-search>
            <q-select
              v-if="item[1].type === 'select'"
              :key="item[0]"
              :disable="item[1].items.length === 0"
              :options="item[1].items"
              :float-label="getString(item[1].label)"
              v-model="structure.parameters[item[0].split('.').pop()]"
            ></q-select>
            <p :key="'property-description' + item[0]">{{  getString(item[1].description) }}</p>
          </template>
        </div>

          <q-btn
            label="Submit"
            color="primary"
            @click.native="startTask"
            class="q-mt-md"
          />
        </div>
      </q-modal-layout>
    </q-modal>
    <!-- #endregion -->
  </div>
</template>
<script>
import qs from 'qs';
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

export default {
  mixins: [filtersMixin],
  components: {
    TableOverview,
  },
  computed: {
    selectedTaskStructure() {
      const { selectedTask } = this.structure;
      if (selectedTask) {
        Object.entries(selectedTask.structure).forEach((item) => {
          if (Object.prototype.hasOwnProperty.call(item[1], 'default') && !this.structure.parameters[item[0].split('.').pop()]) {
            this.$set(this.structure.parameters, item[0].split('.').pop(), item[1].default);
          }
        });
      }
      return selectedTask ? Object.entries(selectedTask.structure) : null;
    },
  },
  data() {
    return {
      validParameterTypes: ['text', 'select'].map(v => ({ label: v, value: v })),
      tasks: [],
      structure: {
        selectedTask: null,
        structures: null,
        parameters: {},
        startTaskParametersModalVisible: false,
      },
      taskStructureBooleanOptions: [
        {
          id: false,
          desc: 'false',
        },
        {
          id: true,
          desc: 'true',
        },
      ],
      rowSelection: [],
      filters: {
        code: '',
        source: [],
      },
      permission: '',
      module: '',
      sourceOptions: [
        {
          label: 'Taak',
          value: 'task',
        },
        {
          label: 'Status',
          value: 'description',
        },
      ],
      searchTerm: '',
      isLoading: false,
      columns: {
        queue: [
          {
            name: 'datetime',
            title: getString('datetime.label'),
            titleClass: 'text-left vcol-s',
            dataClass: 'text-left vcol-s text-ellipsis',
            callback: 'tableFormatTime',
          },
          {
            name: 'label',
            title: getString('module.queue.task.task'),
            titleClass: 'text-left vcol-m',
            dataClass: 'text-left vcol-m text-ellipsis',
            callback: 'getString',
          },
          {
            name: '__slot:task-parameters',
            title: 'Parameters',
            titleClass: 'text-left vcol-s',
            dataClass: 'text-left vcol-s text-ellipsis',
          },
          {
            name: 'status',
            title: 'Status',
            titleClass: 'text-left vcol-s',
            dataClass: 'text-left vcol-s text-ellipsis',
            callback(status) {
              return getString(status.label.toLowerCase());
            },
          },
          {
            name: 'status.description',
            title: 'Script log',
            titleClass: 'text-left vcol-l',
            dataClass: 'text-left vcol-l text-ellipsis',
          },
        ],
        tasks: [
          {
            name: 'label',
            title: getString('module.queue.task.task'),
            titleClass: 'text-left vcol-m',
            dataClass: 'text-left vcol-m text-ellipsis',
            callback: 'getString',
          },
          {
            name: 'description',
            title: getString('module.queue.task.description.title'),
            titleClass: 'text-left vcol-xl',
            dataClass: 'text-left vcol-xl text-ellipsis',
            callback: 'getString',
          },
          {
            name: 'status',
            title: 'Status',
            titleClass: 'text-left vcol-s',
            dataClass: 'text-left vcol-s text-ellipsis',
            callback(status) {
              return getString(`module.queue.status.${status.toLowerCase()}`);
            },
          },
          {
            name: '__slot:task-start',
            title: '',
            titleClass: 'text-right vcol-s',
            dataClass: 'text-right vcol-s text-ellipsis',
          },
        ],
      },
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,
    async searchItem(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`item?code=${terms.toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.items.map(item => ({ label: item.code, id: item.id }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

      // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        done([]);
      }
    },
    itemSelected(key, selected) {
      this.structure.parameters[key] = selected.label;
    },
    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },

    getTaskStructures() {
      this.axios.get('queue/task').then((res) => {
        const tasks = res.data.data;

        this.tasks = Object.entries(tasks).map(({ 0: task, 1: { parameters, runnable } }) => ({
          key: task,
          name: task.split('.').pop(),
          label: getString(task),
          parameters,
          runnable,
        }));
      });
    },

    setSelectedTask(task, toggleParametersModal = true) {
      this.structure.selectedTask = task;

      if (toggleParametersModal) {
        this.toggleStructureParametersModal(true);
      }
    },

    toggleStructureParametersModal(next = null) {
      this.structure.startTaskParametersModalVisible = next !== null
        ? next
        : !this.structure.startTaskParametersModalVisible;
    },

    addParameterToStructure() {
      const parameterCount = this.structure.edit.parameters.length;

      this.structure.edit.parameters = [
        ...this.structure.edit.parameters,
        {
          label: `Parameter ${parameterCount + 1}`,
          type: 'text',
          values: null,
        },
      ];
    },

    startTask() {
      const { selectedTask, parameters } = this.structure;
      Object.keys(parameters).forEach((key) => {
        if (parameters[key] === '') {
          delete parameters[key];
        }
      });
      this.axios.post('queue', qs.stringify({
        task: selectedTask.name,
        parameters: JSON.stringify(parameters),
      })).then(() => {
        this.toggleStructureParametersModal(false);
        this.$q.notify({
          message: `Task ${getString(selectedTask.label)} placed in queue, and will be started soon!`,
          timeout: 3000,
          type: 'positive',
          position: 'top-right',
        });

        // refresh overview table
        EventBus.$emit('refresh-table');

        // unset selected task and parameters
        this.structure.selectedTask = null;
        this.structure.parameters = {};
      });
    },
  },

  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });

    EventBus.$on('task:start', (task) => {
      this.structure.selectedTask = task;
      // show structure parameters modal only if the task structure has parameters defined
      // otherwise, start the task immediately
      if (Array.isArray(this.selectedTaskStructure) && this.selectedTaskStructure.length > 0) {
        this.toggleStructureParametersModal(true);
      } else {
        this.structure.parameters = {};
        this.startTask();
      }
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>
<style lang="stylus">
.container {
  display: grid;
  flex-flow: row wrap;
  height: 100%;
}

.properties {
  &__header {

    h1 {
      font-size: 30px;
      margin-bottom: 15px;
      margin-top: 0px;
    }
    >span {
      label {
        font-weight: bold;
      }

      p {
       font-size: 14px;
       &:first-child{
        margin-bottom: 2px;
       }
      }
    }
  }

  &__content {
    p {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
